import PortalIdParser from 'PortalIdParser';
import userInfo from 'hub-http/userInfo';
import { INITIALIZE_AUTH, UPDATE_GATES } from './constants/ActionTypes';
export const getAuth = () => dispatch => {
  PortalIdParser.get();
  return userInfo().then(({
    user,
    gates,
    portal
  }) => {
    dispatch({
      type: INITIALIZE_AUTH,
      payload: {
        user,
        gates,
        portal
      }
    });
    return {
      user,
      gates,
      portal
    };
  });
};
export const updateGates = gates => ({
  type: UPDATE_GATES,
  payload: gates
});